export default "__VITE_ASSET__DEgYQU5K__"